import React from 'react'

type SVGProps = {
  width?: number | string
  height?: number | string
}

const LogoSVG: React.FC<SVGProps> = ({ width = 120, height = 97 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 120 97"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        d="M88.9286 81.2031H87.0277V97.2307H88.9286V81.2031Z"
        fill="black"
      />
      <path
        d="M94.5361 97.2307V81.2031H104.405V83.0125H96.437V88.255H103.512V90.0643H96.437V97.2307H94.5361Z"
        fill="black"
      />
      <path
        d="M109.81 97.2307V81.2031H119.679V83.0125H111.711V88.255H118.786V90.0643H111.711V95.4236H120V97.2307H109.81Z"
        fill="black"
      />
      <path
        d="M87.8962 71.8935C87.8962 71.2499 88.0199 70.6407 88.2672 70.0636C88.5123 69.4887 88.849 68.9848 89.2772 68.5519C89.7032 68.1214 90.2025 67.7801 90.7751 67.5282C91.3477 67.2785 91.9592 67.1526 92.612 67.1526C93.2532 67.1526 93.8624 67.2785 94.4396 67.5282C95.0168 67.7801 95.5206 68.1214 95.9512 68.5519C96.3841 68.9848 96.7253 69.4887 96.975 70.0636C97.2269 70.6407 97.3529 71.2499 97.3529 71.8935C97.3529 72.544 97.2269 73.1577 96.975 73.728C96.7253 74.3006 96.3841 74.7999 95.9512 75.2282C95.5206 75.6542 95.0168 75.9909 94.4396 76.2382C93.8624 76.4856 93.2532 76.607 92.612 76.607C91.9592 76.607 91.3477 76.4856 90.7751 76.2382C90.2025 75.9909 89.7032 75.6542 89.2772 75.2282C88.849 74.7999 88.5123 74.3006 88.2672 73.728C88.0199 73.1577 87.8962 72.544 87.8962 71.8935ZM88.9933 71.8935C88.9933 72.4042 89.0872 72.8806 89.2772 73.3273C89.4651 73.7716 89.7261 74.1586 90.0559 74.4884C90.3857 74.8182 90.7705 75.0793 91.2103 75.274C91.6523 75.4687 92.1218 75.5649 92.6234 75.5649C93.125 75.5649 93.5968 75.4687 94.0365 75.274C94.4785 75.0793 94.8633 74.8182 95.1931 74.4884C95.5229 74.1586 95.7817 73.7716 95.9718 73.3273C96.1619 72.8806 96.2558 72.4042 96.2558 71.8935C96.2558 71.3828 96.1619 70.9041 95.9718 70.4598C95.7817 70.0155 95.5229 69.6261 95.1931 69.2917C94.8633 68.9573 94.4785 68.694 94.0365 68.4993C93.5968 68.3069 93.125 68.2084 92.6234 68.2084C92.1218 68.2084 91.6523 68.3069 91.2103 68.4993C90.7705 68.694 90.3857 68.9573 90.0559 69.2917C89.7261 69.6261 89.4651 70.0155 89.2772 70.4598C89.0872 70.9041 88.9933 71.3828 88.9933 71.8935Z"
        fill="black"
      />
      <path
        d="M100.139 76.5015V67.2578H105.831V68.3022H101.236V71.3254H105.315V72.3698H101.236V76.5015H100.139Z"
        fill="#424242"
      />
      <path
        d="M12.9151 60.4739L12.6631 62.2832H7.30382L5.29065 76.5014H3.38969L5.40513 62.2832H3.8147e-06L0.251939 60.4739H12.9151Z"
        fill="black"
      />
      <path
        d="M16.9676 67.5257H18.9602C19.6313 67.5257 20.2016 67.4387 20.6665 67.2623C21.1314 67.0883 21.5139 66.8707 21.8116 66.6096C22.1094 66.3508 22.3292 66.0599 22.4758 65.7393C22.6201 65.4209 22.7163 65.114 22.7621 64.8254C22.8079 64.4888 22.7644 64.1635 22.6362 63.8521C22.5056 63.5383 22.3063 63.2635 22.0407 63.0275C21.7727 62.7894 21.4406 62.6039 21.0444 62.4664C20.6482 62.329 20.213 62.2603 19.7389 62.2603H17.7234L16.9676 67.5257ZM13.8093 76.5014L16.0744 60.4739H19.8534C20.3733 60.4739 20.9367 60.554 21.5483 60.7143C22.1575 60.8747 22.7117 61.1312 23.2087 61.4816C23.7034 61.832 24.0974 62.2832 24.3859 62.8329C24.6768 63.3826 24.7684 64.0467 24.6608 64.8254C24.4936 65.9683 24.0699 66.9279 23.392 67.6975C22.7117 68.4693 21.807 68.9755 20.6779 69.2206L23.0828 76.5014H21.0215C20.6253 75.3105 20.2313 74.1218 19.842 72.9309C19.4526 71.7399 19.0587 70.5489 18.6625 69.358H16.7157L15.708 76.5014H13.8093Z"
        fill="black"
      />
      <path
        d="M33.7037 76.6847C32.8815 76.6847 32.1325 76.5702 31.4615 76.3411C30.7881 76.1121 30.227 75.7731 29.7781 75.3219C29.3269 74.873 29.004 74.3119 28.8048 73.6408C28.6055 72.9675 28.5688 72.198 28.6902 71.3276L30.2018 60.4739H32.1028L30.5912 71.2589C30.5133 71.8384 30.5408 72.3537 30.6713 72.8049C30.7996 73.2538 31.0149 73.6317 31.3126 73.9386C31.6104 74.2432 31.9837 74.4768 32.4349 74.6371C32.8838 74.7952 33.3922 74.8753 33.9556 74.8753C35.0871 74.8753 36.0604 74.5684 36.8758 73.95C37.6934 73.3316 38.1858 72.4339 38.353 71.2589L39.8646 60.4739H41.7656L40.254 71.3276C40.1303 72.198 39.8761 72.9675 39.4868 73.6408C39.0974 74.3119 38.6095 74.873 38.0209 75.3219C37.4323 75.7731 36.7727 76.1121 36.0398 76.3411C35.3069 76.5702 34.5282 76.6847 33.7037 76.6847Z"
        fill="black"
      />
      <path
        d="M57.8866 60.4739L57.6346 62.2832H52.2753L50.2621 76.5014H48.3612L50.3767 62.2832H44.9715L45.2235 60.4739H57.8866Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M70.9309 92.5153L70.9355 69.3351H62.143L61.1353 76.5014H59.2366L61.5017 60.4739H63.4026L62.3949 67.5257H70.9355V60.4739H72.8364L72.8319 90.7059H81.1205V92.5153H70.9309Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.43475 21.9475C28.6077 53.5643 70.4066 23.7185 102.305 59.6717C78.9031 35.0064 36.9359 65.5899 4.43475 21.9475Z"
        fill="#AC47BB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.2693 3.76916C46.5771 34.9142 87.1453 23.0166 102.305 59.6725C90.7506 34.1388 49.8485 46.5444 36.2693 3.76916Z"
        fill="#C263D2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M67.5797 1.00017C67.2744 26.8401 100.467 28.4974 102.304 59.6727C100.273 37.6915 66.7203 36.384 67.5797 1.00017Z"
        fill="#D68FE3"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width="120"
          height="96.23"
          fill="white"
          transform="translate(120 97) rotate(-180)"
        />
      </clipPath>
    </defs>
  </svg>
)

export default LogoSVG
